export default "__VITE_ASSET__DEmWI2nH__"